import React, { useState, useEffect } from 'react';
import { Box, Button, TextField, Typography, Link } from '@mui/material';
import AuthLayout from '../../components/auth/AuthLayout';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate, useLocation } from 'react-router-dom';
import { useNotification } from '../../contexts/NotificationContext';
import { getFirebaseErrorMessage } from '../../utils/errorMessages';

function Login() {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const { showNotification } = useNotification();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await login(email, password);
            const destination = location.state?.from || '/';
            navigate(destination);
            showNotification('ログインしました', 'success');
        } catch (error) {
            // Firebaseのエラーメッセージを日本語化
            const errorMessage = getFirebaseErrorMessage(error);
            showNotification(errorMessage, 'error');
        }
    };

    return (
        <AuthLayout>
            <Typography
                variant="h5"
                component="h1"
                align="center"
                sx={{
                    fontSize: '1.2rem',
                    fontWeight: 500,
                    mb: 1
                }}
            >
                ログイン
            </Typography>
            <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1
                }}
            >
                <TextField
                    required
                    fullWidth
                    id="email"
                    label="メールアドレス"
                    name="email"
                    autoComplete="email"
                    autoFocus
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    size="small"
                    margin="none"
                />
                <TextField
                    required
                    fullWidth
                    name="password"
                    label="パスワード"
                    type="password"
                    id="password"
                    autoComplete="current-password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    size="small"
                    margin="none"
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    size="small"
                >
                    ログイン
                </Button>
                <Box sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 1,
                    pt: 0.5
                }}>
                    <Link
                        href="/register"
                        variant="body2"
                        sx={{
                            color: 'primary.main',
                            textDecoration: 'none',
                            fontSize: '0.875rem',
                            textAlign: 'center',
                            '&:hover': {
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        アカウント新規作成はこちら
                    </Link>
                    <Link
                        href="/forgot-password"
                        variant="body2"
                        sx={{
                            color: 'text.secondary',
                            textDecoration: 'none',
                            fontSize: '0.875rem',
                            textAlign: 'center',
                            '&:hover': {
                                textDecoration: 'underline'
                            }
                        }}
                    >
                        パスワードをお忘れの方はこちら
                    </Link>
                </Box>
            </Box>
        </AuthLayout>
    );
}

export default Login; 